import { useSelector } from "react-redux";
import { RootState } from "../../../store/storeConfig";
import storeRTK from "../../../store/storeRTK";
import { HistoryContainer } from "../../common/HistoryContainer/HistoryContainer";
import { VoiceMail } from "../../../types/callback.type";
import { setHistoryfilterVoicemailCount } from "../../../actions/voicemail";

const VoicemailHistory = () => {
  const history = useSelector((state: RootState) => state.history);
  const { voicemail } = history || {};

  return (
    <HistoryContainer<VoiceMail>
      data={voicemail}
      type="voicemail"
      setCount={(count) =>
        storeRTK.dispatch(setHistoryfilterVoicemailCount(count))
      }
      emptyTitle="No Voicemail history"
      emptyDescription="Wait for a voicemail"
    />
  );
};

export default VoicemailHistory;
